<template>
  <div class="content-result" v-if="isShow">
    <div class="big-bg">
      <div class="result-box flex flex-column flex-center items-center">
        <div class="title">{{ title }}</div>
        <div class="sub-title">{{ SubTitle }}</div>
        <div class="close pointer" @click="close">X</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Result",
  props: {
    title: {
      type: String,
      default: "",
    },
    SubTitle: {
      type: String,
      default: "",
    },
    isShow: {
      tyoe: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tipShow: false,
    };
  },
  watch: {
    isShow: {
      immediate: true,
      handler(val) {
        this.tipShow = val;
      },
    },
  },
  methods: {
    close() {
      this.$emit("change", this.tipShow);
    },
  },
};
</script>

<style lang="less" scoped>
.content-result {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1111111111;
}
.big-bg {
  width: 100%;
  height: 100%;
  // background-image: url(../assets/images/ditu.png);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 111111111111;
  .result-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 605px;
    height: 300px;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 0px 15px rgba(28, 101, 196, 0.3);
    .title {
      font-size: 18px;
      color: #3b426b;
    }
    .sub-title {
      font-size: 14px;
      color: #ccd9e9;
    }
    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      right: 18px;
      top: 18px;
      border-radius: 50%;
      line-height: 30px;
      text-align: center;
      color: #1c65c4;
      border: 2px solid #1c65c4;
      font-weight: bold;
      box-sizing: border-box;
    }
  }
}
</style>